module.exports = __webpack_public_path__ + "components/country-flag/static/sb-735299098f0831e5e4a5cf9df02d7a9b.svg";